import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const LANGUAGE_STORAGE_KEY = "mayamind_preferred_language";

// Each src/locales/<language>/<namespace>.json is picked up automatically —
// add a new file to add a namespace or language, no import wiring needed
// here. A namespace missing for a language falls back to English via
// `fallbackLng` instead of erroring.
const modules = import.meta.glob<{ default: Record<string, unknown> }>(
  "../../locales/*/*.json",
  { eager: true },
);

const resources: Record<string, Record<string, Record<string, unknown>>> = {};
const namespaces = new Set<string>();

for (const path in modules) {
  const match = /\/locales\/([a-zA-Z-]+)\/([a-zA-Z]+)\.json$/.exec(path);
  if (!match) continue;
  const [, language, namespace] = match;
  resources[language] ??= {};
  resources[language][namespace] = modules[path].default;
  namespaces.add(namespace);
}

const cachedLanguage =
  typeof window !== "undefined"
    ? localStorage.getItem(LANGUAGE_STORAGE_KEY)
    : null;

void i18n.use(initReactI18next).init({
  resources,
  ns: Array.from(namespaces),
  defaultNS: "common",
  lng: cachedLanguage ?? "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
